export default "__VITE_PUBLIC_ASSET__cf908f6d__"